import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const ServicesSection = () => {
  const services = [
    {
      title: 'Basement Development',
      description: 'Complete basement renovations, from framing to finishing. Create your dream entertainment space, home office, or legal suite.',
      image: '/hero-basement.png',
      link: '/basements',
      featured: true,
      alt: 'Calgary basement renovation with electric fireplace and modern living space'
    },
    {
      title: 'Bathroom Renovation',
      description: 'Luxury bathroom transformations featuring custom showers, premium fixtures, and timeless design.',
      image: 'https://customer-assets.emergentagent.com/job_built-to-last-4/artifacts/n22zq6v8_1000068955.jpg',
      link: '/bathrooms',
      featured: true,
      alt: 'Calgary bathroom renovation with marble tile and freestanding tub'
    },
    {
      title: 'Custom Features',
      description: 'Built-ins, feature walls, fireplaces, and architectural details that elevate your space.',
      image: 'https://customer-assets.emergentagent.com/job_built-to-last-4/artifacts/y82vqawa_1000069194.jpg',
      link: '/custom-features',
      featured: false,
      alt: 'Custom fireplace Calgary with natural stone surround and wood beam mantel'
    },
  ];

  return (
    <section className="py-24 md:py-32 bg-white" data-testid="services-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-[#c5a059] text-sm uppercase tracking-[0.3em] mb-4">
            What We Do
          </p>
          <h2 className="font-heading text-4xl md:text-5xl font-semibold text-[#0f172a] mb-6">
            Our Services
          </h2>
          <p className="text-slate-600 text-lg max-w-2xl mx-auto">
            From complete basement developments to luxury bathroom renovations, 
            we bring your vision to life with quality craftsmanship.
          </p>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {services.map((service, index) => (
            <Link
              key={service.title}
              to={service.link}
              className={`service-card group relative overflow-hidden ${
                index === 0 ? 'md:row-span-2 min-h-[500px] md:min-h-[700px]' : 'min-h-[300px] md:min-h-[340px]'
              }`}
              data-testid={`service-card-${service.title.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <img
                src={service.image}
                alt={service.alt}
                className="absolute inset-0 w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 z-10 flex flex-col justify-end p-8 md:p-10">
                <p className="text-[#c5a059] text-xs uppercase tracking-[0.2em] mb-2">
                  {service.featured ? 'Featured Service' : 'Custom Work'}
                </p>
                <h3 className="font-heading text-2xl md:text-3xl font-semibold text-white mb-3">
                  {service.title}
                </h3>
                <p className="text-white/80 mb-4 line-clamp-2">
                  {service.description}
                </p>
                <div className="flex items-center gap-2 text-[#c5a059] text-sm uppercase tracking-widest font-medium group-hover:gap-4 transition-all">
                  <span>Learn More</span>
                  <ArrowRight size={16} />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
